import React from 'react';
import { FadeIn } from './FadeIn';
export function Bonuses() {
  const bonuses = [{
    num: '01',
    title: 'Checklists Imprimibles para Sesiones',
    desc: 'Listas para organizar materiales, objetivos y cierre de cada sesión.',
    price: '$12.000'
  }, {
    num: '02',
    title: 'Planillas de Seguimiento y Registro Profesional',
    desc: 'Registro de avances, observaciones y evolución.',
    price: '$15.000'
  }, {
    num: '03',
    title: 'Guía de Organización del Consultorio y Material',
    desc: 'Ordenar el espacio y clasificar materiales para optimizar tiempos.',
    price: '$10.000'
  }, {
    num: '04',
    title: 'Banco de Frases Clínicas, Devoluciones y Redacción Profesional',
    desc: 'Frases y estructuras útiles para informes y devoluciones.',
    price: '$11.000'
  }, {
    num: '05',
    title: 'Matriz Express de Intervención y Toma de Decisiones',
    desc: 'Priorizar objetivos y decidir qué trabajar primero.',
    price: '$13.000'
  }, {
    num: '06',
    title: 'Guía Práctica de Intervención, Adaptación y Uso del Material',
    desc: 'Orientaciones para adaptar actividades y aprovechar cada recurso.',
    price: '$9.000'
  }];
  return <section className="pt-8 pb-12 px-3 bg-cream" data-id="element-31">
      <div className="max-w-5xl mx-auto" data-id="element-32">
        <FadeIn className="text-center mb-8" data-id="element-33">
          <h2 className="font-display text-2xl md:text-3xl font-bold text-ink mb-2" data-id="element-34">
            Bonos estratégicos incluidos
          </h2>
          <p className="text-sm font-medium text-accent" data-id="element-35">
            Incluidos sin costo adicional en ambas ofertas.
          </p>
        </FadeIn>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4" data-id="element-36">
          {bonuses.map((bonus, idx) => <FadeIn key={idx} delay={idx * 0.1} className="bg-accent/[0.03] border border-accent/20 rounded-xl p-5 flex flex-col h-full hover:border-accent/40 transition-colors relative overflow-hidden group" data-id="element-37">
              <div className="absolute top-0 right-0 w-24 h-24 bg-accent/5 rounded-bl-full -mr-8 -mt-8 transition-transform group-hover:scale-110" data-id="element-38" />

              <div className="flex items-center justify-between mb-4 relative z-10" data-id="element-39">
                <span className="text-2xl font-black text-ink/10 font-display" data-id="element-40">
                  {bonus.num}
                </span>
                <span className="bg-accent/10 text-accent text-[10px] font-bold px-2.5 py-1 rounded-full uppercase tracking-wider border border-accent/20" data-id="element-41">
                  Bono {parseInt(bonus.num)}
                </span>
              </div>

              <h3 className="text-sm font-bold text-ink mb-2 relative z-10" data-id="element-42">
                {bonus.title}
              </h3>

              <p className="text-xs text-muted mb-4 flex-1 relative z-10 leading-relaxed" data-id="element-43">
                {bonus.desc}
              </p>

              <div className="flex items-center justify-between pt-3 border-t border-ink/10 relative z-10" data-id="element-44">
                <span className="text-muted/70 line-through text-xs font-medium" data-id="element-45">
                  {bonus.price}
                </span>
                <span className="bg-accent text-black font-bold text-xs px-3 py-1 rounded-full uppercase tracking-wide" data-id="element-46">
                  Gratis
                </span>
              </div>
            </FadeIn>)}
        </div>

        <FadeIn delay={0.6} className="text-center mt-8" data-id="element-47">
          <p className="text-muted text-sm max-w-2xl mx-auto" data-id="element-48">
            Pensados para complementar el sistema y ordenar tu práctica
            profesional.
          </p>
        </FadeIn>
      </div>
    </section>;
}